/**
 * Which contour to sign into when an account has several.
 *
 * The registry marks one vault `is_default`, and that was the only thing the
 * login looked at — so an account with six grants always landed in the same
 * one and had to switch by hand after every login. What people actually expect
 * is the contour they worked in last, so it is remembered here.
 *
 * Kept in this browser rather than in the registry on purpose: the default is a
 * property of the account, the last choice is a property of the machine you sit
 * at — a laptop that lives in test should not drag production along with it.
 * Keyed by login, because more than one person shares some of these machines.
 */
const PREFIX = 'ism.portal.lastVault.';

function key(login: string): string {
  return `${PREFIX}${login.trim().toLowerCase()}`;
}

export function readLastVault(login: string): string | null {
  if (!login) return null;
  try {
    return localStorage.getItem(key(login));
  } catch {
    // Private mode / storage disabled — the default is still a fine answer.
    return null;
  }
}

export function rememberLastVault(login: string, vaultId: string): void {
  if (!login || !vaultId) return;
  try {
    localStorage.setItem(key(login), vaultId);
  } catch {
    /* nothing to do: remembering is a convenience, not a requirement */
  }
}
